import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import Cookies from "js-cookie";
import { VerifiedUserDataType } from "@/types/api/auth";

interface AuthState {
    user: VerifiedUserDataType | null;
    contact: string;
    token: string | null;
    timeLimit: string | null;
    setContact: (contact: string) => void;
    setToken: (token: string | undefined) => void;
    setTimeLimit: (timeLimit: string) => void;
    setUser: (user?: VerifiedUserDataType) => void;
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set) => ({
            user: null,
            contact: "",
            token: Cookies.get("token") || null,
            timeLimit: null,
            setContact: (contact) => set({ contact }),
            setToken: (token) => {
                if (token) {
                    Cookies.set("token", token, {
                        expires: 2,
                        secure: true,
                        sameSite: "strict",
                        path: "/"
                    });
                    console.log("set called");
                } else {
                    Cookies.remove("token");
                    console.log("remove called");
                }
                set({ token });
            },
            setTimeLimit: (timeLimit) => set({ timeLimit }),
            setUser: (user) => set({ user }),
        }),
        {
            name: "auth-storage",
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({
                user: state.user,
                contact: state.contact,
                timeLimit: state.timeLimit,
            }),
        }
    )
);